module.exports = __webpack_public_path__ + "img/c_slider_aide.aadf1a49.jpg";